export default function CapabilitiesSection() {
  const capabilities = [
    {
      label: 'Scalability',
      description: 'Designing systems that grow gracefully, handling increased complexity and demand without degradation.',
      bgClass: 'bg-accent-100/60',
      imageUrl: 'https://readdy.ai/api/search-image?query=Abstract%20geometric%20composition%20with%20expanding%20concentric%20circles%20and%20radiating%20lines%20in%20soft%20warm%20pink%20and%20cream%20tones%2C%20minimalist%20growth%20pattern%2C%20clean%20design%2C%20no%20text%2C%20representing%20scalability%20concept&width=400&height=480&seq=sivora-cap-scale&orientation=portrait',
    },
    {
      label: 'Maintainability',
      description: 'Writing clear, modular code with rigorous documentation and consistent patterns for long-term sustainability.',
      bgClass: 'bg-secondary-100/60',
      imageUrl: 'https://readdy.ai/api/search-image?query=Abstract%20geometric%20pattern%20of%20organized%20rectangular%20modules%20and%20clean%20grid%20lines%20in%20soft%20mint%20green%20and%20cream%20tones%2C%20minimalist%20structured%20design%2C%20no%20text%2C%20evoking%20organized%20maintainable%20systems&width=400&height=480&seq=sivora-cap-maint&orientation=portrait',
    },
    {
      label: 'Usability',
      description: 'Applying user-centered design principles to create intuitive, accessible, and enjoyable interaction experiences.',
      bgClass: 'bg-background-300/60',
      imageUrl: 'https://readdy.ai/api/search-image?query=Abstract%20flowing%20curved%20lines%20and%20soft%20overlapping%20circles%20in%20light%20warm%20gray%20and%20cream%20tones%2C%20minimalist%20organic%20design%2C%20no%20text%2C%20representing%20intuitive%20user%20experience%20and%20accessibility&width=400&height=480&seq=sivora-cap-usable&orientation=portrait',
    },
    {
      label: 'Innovation',
      description: 'Continuously exploring new technologies and evolving internal processes to maintain high technical excellence.',
      bgClass: 'bg-primary-100/50',
      imageUrl: 'https://readdy.ai/api/search-image?query=Abstract%20dynamic%20geometric%20shapes%20with%20intersecting%20diagonal%20lines%20and%20dots%20in%20warm%20golden%20yellow%20brown%20and%20cream%20tones%2C%20minimalist%20forward%20motion%20design%2C%20no%20text%2C%20evoking%20innovation%20and%20progress&width=400&height=480&seq=sivora-cap-innov&orientation=portrait',
    },
  ];

  return (
    <section className="w-full bg-background-100 px-10 md:px-16 lg:px-20 py-20 md:py-28" aria-labelledby="capabilities-heading">
      {/* Top zone */}
      <div className="relative">
        {/* Decorative rotated square */}
        <div className="absolute top-0 right-0 w-6 h-6 border border-foreground-300 rotate-12 hidden lg:block" aria-hidden="true"></div>

        {/* Auxiliary title */}
        <p className="font-heading text-xs text-foreground-400 tracking-wide mb-4">
          core strengths
        </p>

        {/* Main title */}
        <h2 id="capabilities-heading" className="font-heading text-4xl md:text-5xl lg:text-[4rem] leading-[1.05] text-foreground-950 font-bold max-w-2xl">
          <span className="block">Engineering</span>
          <span className="block">
            <em className="font-heading italic font-normal">capabilities</em>
          </span>
        </h2>
      </div>

      {/* Four cards grid */}
      <div className="mt-16 md:mt-20 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
        {capabilities.map((cap) => (
          <div key={cap.label} className={`${cap.bgClass} rounded-2xl overflow-hidden`}>
            {/* Image area */}
            <div className="h-56 md:h-64 relative">
              <img
                src={cap.imageUrl}
                alt={`Abstract geometric composition representing ${cap.label.toLowerCase()}`}
                title={`${cap.label} - Engineering Capability`}
                className="w-full h-full object-cover object-top"
              />
            </div>
            {/* Info strip */}
            <div className="bg-background-50 p-6">
              <h3 className="font-sans text-base font-semibold text-foreground-900">{cap.label}</h3>
              <p className="mt-2 text-xs md:text-sm text-foreground-500 font-body font-light leading-relaxed">
                {cap.description}
              </p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}